﻿import { getAccessToken } from "../services/msal";

// TODO later consider refactor to centralized apiClient & updating all controllers

export abstract class CrudFunctions {

    public static async getData(url: string) {
        return apiFetch(url, { method: "GET", responseType: "json" });
    }

    public static async getDataBlob(url: string) {
        return apiFetch(url, { method: "GET", responseType: "blob" });
    }

    public static async postDataBlob(url: string, obj: any) {
        return apiFetch(url, { method: "POST", body: obj, responseType: "blob" });
    }

    public static async getDataBoolean(url: string) {
        const text = await apiFetch(url, { method: "GET", responseType: "text" });
        return text.toLowerCase() === "true";
    }

    public static async postData(url: string, body?: any) {
        return apiFetch(url, { method: "POST", body, responseType: "json" });
    }

    public static async putData(url: string, body?: any) {
        return apiFetch(url, { method: "PUT", body, responseType: "json" });
    }

    public static async deleteData(url: string) {
        return apiFetch(url, { method: "DELETE" });
    }
}

async function apiFetch(
    url: string,
    init: RequestInit & { responseType?: "json" | "text" | "blob" } = {}
) {

    const headers = mergeHeaders({ Accept: "application/json" }, init.headers);

    const isFormData = init.body instanceof FormData;
    const isJsonBody = init.body && typeof init.body === "object" && !isFormData;
    if (isJsonBody) {
        headers.set("Content-Type", "application/json");
        init.body = JSON.stringify(init.body);
    }

    const attachToken = sameOrigin(url) && !isBlobUrl(url) && !hasAuthHeader(init);
    if (attachToken) {
        const token = await getAccessToken();
        if (token) headers.set("Authorization", `Bearer ${token}`);
    }

    // Append /api/ segement to url if needed 
    if (sameOrigin(url) && !isBlobUrl(url)) {
        const prefix = "/api/";
        const normalizedUrl = url.startsWith("/") ? url : `/${url}`;
        if (!normalizedUrl.startsWith(prefix)) {
            // Remove leading slash if it exists to avoid //api/
            const cleanUrl = url.startsWith("/") ? url.substring(1) : url;
            url = `${prefix}${cleanUrl}`;
        }
    }

    const resp = await fetch(url, { ...init, headers, credentials: init.credentials ?? "same-origin" });
    /** credentials: 
     * 'omit' – Never send cookies/HTTP auth; never store received cookies.
     * 'same-origin' (default) – Send cookies only if the request is to the same origin (same scheme + host + port). For cross-origin requests, cookies are omitted.
'    * 'include' – Always send cookies, even to cross-origin requests.
     * Todo later - when API moves to diff origin, use 'include'
     */

    if (resp.status === 204 /*No Content*/) return undefined;
    if (resp.status === 503 /*Service Unavailable*/) {
        // Dispatch a global event to prevent application state loss
        // App.tsx will handle and display a service unavailable dialog
        window.dispatchEvent(new CustomEvent('SHOW_SERVICEUNAVAILABLE_SCREEN'));
        return Promise.reject({ status: 503, message: "Still warming up or trying to reach servers..." });
    }
    if (resp.ok) {
        if (init.responseType === "blob") return await resp.blob();
        if (init.responseType === "text") return await resp.text();
        if (init.responseType === "json") return await resp.json();
        // Default behavior and fallbacks
        const contentType = resp.headers.get("content-type") ?? "";
        if (contentType.includes("application/json")) return await resp.json();
        // Backward compatibility (If no content-type AND empty body → return null)
        const text = await resp.text();
        if (!contentType && text === "") return null;
        return text;
    }

    throw resp;
    // TODO consider:
    /*
    //Wrap the Response into a custom Error subclass, so you keep stack traces and structured HTTP info:    
    const errText = await resp.text();
    throw new HttpError(
      `API ${resp.status} ${resp.statusText}`,
      { status: resp.status, statusText: resp.statusText, body: errText, url: resp.url }
    );

    */
}

function sameOrigin(url: string) {
    const u = new URL(url, window.location.origin);
    return u.origin === window.location.origin;
}
function isBlobUrl(url: string) {
    // TODO - need later for when we store blobs in a different service
    return false;
}
function hasAuthHeader(init?: RequestInit) {
    return !!init?.headers && new Headers(init.headers).has("Authorization");
}
function mergeHeaders(a?: HeadersInit, b?: HeadersInit) {
    const h = new Headers(a);
    new Headers(b).forEach((v, k) => h.set(k, v));
    return h;
}